import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=46565d63&scoped=true"
import script from "./inquire.vue?vue&type=script&lang=js"
export * from "./inquire.vue?vue&type=script&lang=js"
import style0 from "./inquire.vue?vue&type=style&index=0&id=46565d63&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46565d63",
  null
  
)

export default component.exports